import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-[#A1A1AA] hover:text-white mb-6 transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          Back
        </button>

        <h1 className="text-3xl font-bold text-[#FF2E63] mb-2">Terms of Service</h1>
        <p className="text-[#A1A1AA] mb-8">Last updated: February 2025</p>

        <div className="space-y-8 text-[#E4E4E7]">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Beta Testing Agreement</h2>
            <p className="leading-relaxed">
              Welcome to PULSE Beta! By using this app during the beta testing period, you acknowledge that:
            </p>
            <ul className="list-disc list-inside mt-3 space-y-2 text-[#A1A1AA]">
              <li>This is a beta version and may contain bugs or incomplete features</li>
              <li>Your feedback helps us improve the app for everyone</li>
              <li>Features may change or be removed without notice</li>
              <li>We may reset data during the beta period if necessary</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Eligibility</h2>
            <p className="leading-relaxed">
              You must be at least 18 years old to use PULSE. By creating an account, you confirm that you meet this age requirement. We reserve the right to verify your age and terminate accounts that violate this requirement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Your Account</h2>
            <p className="leading-relaxed">
              You are responsible for maintaining the security of your account. Keep your password safe and do not share your login credentials. You are responsible for all activity that occurs under your account.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Community Guidelines</h2>
            <p className="leading-relaxed mb-3">
              PULSE is a community built on respect. You agree NOT to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-[#A1A1AA]">
              <li>Harass, bully, or threaten other users</li>
              <li>Post illegal, harmful, or explicit content involving minors</li>
              <li>Impersonate others or create fake profiles</li>
              <li>Spam, scam, or solicit money from other users</li>
              <li>Share others' private information without consent</li>
              <li>Use the app for commercial purposes without permission</li>
              <li>Attempt to hack, exploit, or disrupt the service</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Content You Post</h2>
            <p className="leading-relaxed">
              You own the content you post, but grant us permission to display it within the app. You confirm that you have the right to share any photos or content you upload. We may remove content that violates our guidelines.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Safety</h2>
            <p className="leading-relaxed">
              While we work to create a safe environment, we cannot guarantee the identity or intentions of other users. Always meet in public places, tell someone where you're going, and trust your instincts. Report any suspicious behavior.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Account Termination</h2>
            <p className="leading-relaxed">
              We may suspend or terminate accounts that violate these terms. You can delete your account at any time through the app settings. Upon deletion, your profile and messages will be removed.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Limitation of Liability</h2>
            <p className="leading-relaxed">
              PULSE is provided "as is" during the beta period. We are not responsible for any damages arising from your use of the app, interactions with other users, or technical issues.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Changes to Terms</h2>
            <p className="leading-relaxed">
              We may update these terms as the app evolves. Continued use after changes means you accept the new terms. We'll notify you of significant changes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">10. Contact Us</h2>
            <p className="leading-relaxed">
              Questions about these terms? Reach out to us through the app's feedback feature or contact our support team.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-[#52525B] text-sm">
          <p>PULSE - Connect with your community</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
